export const LEGE_VOORKEUREN = { verborgen_categorieen: [], verborgen_subgroepen: [], verborgen_items: [], favorieten: [], volgorde_categorieen: [] };

export const subKey = (cat, sub) => `${cat}|${sub}`;
export const itemKey = (it) => it.to;

/** Past de persoonlijke indeling toe: volgorde, favorieten bovenaan, verborgen onderdelen apart. */
export function pasVoorkeurenToe(groups, vk) {
  const v = { ...LEGE_VOORKEUREN, ...(vk || {}) };
  const hiddenCat = new Set(v.verborgen_categorieen);
  const hiddenSub = new Set(v.verborgen_subgroepen);
  const hiddenItem = new Set(v.verborgen_items);
  const favSet = new Set(v.favorieten);

  const volgorde = v.volgorde_categorieen;
  const gesorteerd = [...groups].sort((a, b) => {
    const ia = volgorde.indexOf(a.cat), ib = volgorde.indexOf(b.cat);
    if (ia === -1 && ib === -1) return 0;
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

  const zichtbaar = [];
  const verborgen = []; // [{ soort: 'categorie'|'subgroep'|'item', cat, sub, items, label }]
  const favorieten = [];
  for (const g of gesorteerd) {
    g.items.forEach((it) => { if (favSet.has(itemKey(it))) favorieten.push({ ...it, cat: g.cat }); });
    if (hiddenCat.has(g.cat)) {
      verborgen.push({ soort: "categorie", key: g.cat, cat: g.cat, label: g.cat, icon: g.icon, items: g.items });
      continue;
    }
    const rest = [];
    const subBuckets = {};
    for (const it of g.items) {
      if (it.subgroup && hiddenSub.has(subKey(g.cat, it.subgroup))) {
        (subBuckets[it.subgroup] = subBuckets[it.subgroup] || []).push(it);
      } else if (hiddenItem.has(itemKey(it))) {
        verborgen.push({ soort: "item", key: itemKey(it), cat: g.cat, sub: it.subgroup, label: it.label, icon: it.icon, items: [it] });
      } else {
        rest.push(it);
      }
    }
    Object.entries(subBuckets).forEach(([sub, items]) =>
      verborgen.push({ soort: "subgroep", key: subKey(g.cat, sub), cat: g.cat, sub, label: `${g.cat} › ${sub}`, icon: g.icon, items }));
    if (rest.length) zichtbaar.push({ ...g, items: rest });
  }
  favorieten.sort((a, b) => v.favorieten.indexOf(itemKey(a)) - v.favorieten.indexOf(itemKey(b)));
  return { zichtbaar, verborgen, favorieten, voorkeuren: v };
}

export function toggleInLijst(lijst, key) {
  return lijst.includes(key) ? lijst.filter((k) => k !== key) : [...lijst, key];
}

export function verplaats(lijst, key, richting) {
  const i = lijst.indexOf(key);
  const j = i + richting;
  if (i < 0 || j < 0 || j >= lijst.length) return lijst;
  const kopie = [...lijst];
  [kopie[i], kopie[j]] = [kopie[j], kopie[i]];
  return kopie;
}
